import { awaitAllSafely } from '@vy/utils';
import type { Control } from 'react-hook-form';
import { useQueryClient } from 'react-query';
import { useStripeConnect as useStripeMutationConnect } from '../../../../../../hooks/requests/use-stripe-connect';
import { queryKeys } from '../../../../../../services/query-key/query-keys';
import { runMutation } from '../../../../../../utils/vy-mutation';
import type { StripeConfigurationFormValues } from '../configure-stripe-integration/StripeConfigurationFormSchema';
import type { StripeRegisterFormValues } from '../register-to-stripe/StripeRegisterFormSchema';

export const useConnectToStripe = (
  control: Control<StripeRegisterFormValues | StripeConfigurationFormValues>,
) => {
  const queryClient = useQueryClient();
  const { setError } = control;
  const mutateAsyncStripeConnect = useStripeMutationConnect();

  return (apiToken: string) =>
    runMutation(
      mutateAsyncStripeConnect,
      { apiToken },
      {
        pending: 'Connecting...',
        success: 'Connected',
        error: 'Failed to connect',
      },
      {
        onError: () => {
          setError('apiToken', {
            type: 'manual',
            message: 'Invalid API token',
          });
        },
        onSuccess: () =>
          awaitAllSafely(
            queryClient.invalidateQueries(queryKeys.connectedIntegrations()),
            queryClient.invalidateQueries(queryKeys.integrationSettings()),
          ),
      },
    );
};
